// extracted by mini-css-extract-plugin
export default {"main":"footer_main__dO4uD","bar":"footer_bar__rR9NX","copy":"footer_copy__B8M8g"};